export default {"src":"/login-app/[GIT_HASH]/_next/static/media/line_style.acb4724e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};